import { csx } from '@vtex/admin-ui'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

export default function SectionTitle({ children, contentClassName, ...rest }) {
  return (
    <div>
      <h2
        className="ma0 ml5 ml4-ns pv3 pv4-ns f3 f2-ns lh-copy c-muted-3"
        {...rest}
      >
        <span
          className={classNames(
            csx({
              fontWeight: 'normal',
            }),
            contentClassName || 'ml3-ns'
          )}
        >
          {children}
        </span>
      </h2>
    </div>
  )
}

SectionTitle.propTypes = {
  children: PropTypes.node,
  contentClassName: PropTypes.string,
}
